import React from "react";
import { useHistory } from "react-router-dom";
import { Card, CardMedia, CardContent, Typography } from "@mui/material";
// import { workSpace } from "../../Constant";
import {
  cardStyle,
  cardTitle,
  cardContant,
  cardSubtitle,
} from "./DashBoardStyling";

const DashBoard = (props) => {

  const history = useHistory();
  

  const calculateDays = (date1) => {
    const d1 = new Date(date1);
    const d2 = new Date();
    const diffDates = parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10);
    if (diffDates > 0) {
      return diffDates + " years ago";
    } else {
      return (
        parseInt((d2 - d1) / (1000 * 60 * 60 * 24 * 30 * 12), 10) +
        " months ago"
      );
    }
  };

  return (
    <>
      <Card
        style={cardStyle}
        onClick={() => history.push(`/videopage/${props.id}`)}
        className="video-tile-link"
      >
        <CardMedia
          component="img"
          height="140"
          image={props.image}
          alt={props.title}
          className="video-tile"
          
        />
        <CardContent style={cardContant}>
          <Typography
            gutterBottom
            // variant="body1"
            // component="body1"
            style={cardTitle}
          >
            {props.title}
          </Typography>
          <Typography
            // variant="subtitle2"
            // component="subtitle2"
            style={cardSubtitle}
          >
            {calculateDays(props.releaseDate)}
          </Typography>
        </CardContent>
      </Card>
    </>
  );
};

export default DashBoard;
